<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      :filename= "nomeArquivo"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="conteiner_pdf_grafico">
          <div class="pdf-header">
            <div class="nome_relatorio-pdf">
              {{ nomeArquivo }}
            </div>
          </div>
        </div>

        <div class="filtro_parametros-pdf">
         <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="filter-text">
                        <div class="border-filter">
                        <i class="fas fa-filter icon-filter d- mr-2 ml-2"></i>
                        </div>
                        <div class="header_filtro">Filtros Utilizados</div>
                    </div>
                    <div class="container_header_filtro_periodo_atividade">
                        <div class="status_filtro">
                            Atividade:  <strong class="filtrostatus">{{filtros == null ? 'N/D' : filtros.atividade == null ? "Todas" : filtros.atividade}}</strong>
                        </div>
                        <div class="periodo_filtro">
                            Período:  <strong class="filtrostatus">{{(filtros == null ? 'N/D' : filtros.dataInicio == null || filtros.dataInicio == '' ?  "N/D" : filtros.dataInicio) + ' - ' + (filtros == null ? 'N/D' : filtros.dataFim == null || filtros.dataFim == '' ?  "N/D" : filtros.dataFim)  }} </strong>
                        </div>
                    </div>
                    <div class="container_header_filtro">
                        <div class="periodo_filtro" v-if="filtros.responsavel !== null">
                            Responsável:  <strong  class="filtrostatus">{{filtros == null ? 'N/D' : filtros.responsavel == null || filtros.codigoAPR == ''  ?  "N/D" : filtros.responsavel}}</strong>
                        </div>
                        <div class="periodo_filtro">
                            Código:  <strong  class="filtrostatus">{{ filtros == null ? 'N/D' :filtros.codigoAPR == null || filtros.codigoAPR == '' ?  "N/D" : filtros.codigoAPR}}</strong>
                        </div>
                    </div>
                    <div class="container_header_filtro">
                        <div class="periodo_filtro">
                            Obra:  <strong  class="filtrostatus">{{!filtros ? 'N/D' : filtros.obra == null || filtros.obra == ''  ?  "N/D" : filtros.obra}}</strong>
                        </div>
                    </div>
                </div>
                <div class="report-qta">
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{ dataRelatoioQma.length }}
                        </div>
                        <div class="text-filter">
                            Total {{ report === 0 ? 'LV' : report === 1 ? 'PIT' : report === 2 ? 'PIVS' : '' }}
                        </div>
                    </div>
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{contagemPendentes || 0 }}
                        </div>
                        <div class="text-filter">
                            {{ report === 0 ? 'LV' : report === 1 ? 'PIT' : report === 2 ? 'PIVS' : '' }} em Andamento
                        </div>
                    </div>
                </div>
            </div>
            <div class="container_pdffiltro">
                <div class="container_ocorrencias_filtradas">
                    <div style="width: 10%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Cód. {{ report === 0 ? 'LV' : report === 1 ? 'PIT' : 'PIVS' }}
                    </div>
                    <div style="width: 10%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Revisão
                    </div>
                    <div style="width: 10%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Área
                    </div>
                    <div style="width: 15%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Atividade
                    </div>
                    <div style="width: 15%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Resp.
                    </div>
                    <div style="width: 15%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Dt. Aplicação
                    </div>
                    <div style="width: 15%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Dt. Aprovação
                    </div>
                    <div style="width: 20%; display: flex ;color: #FFF; font-family: 'Poppins'; font-size: 13px; font-style: normal; justify-content: center; font-weight: 400; line-height: 27px;">
                        Status
                    </div>
                </div>
                <div class="container_ocorrencias" v-for=" obj in dataRelatoioQma" :key="obj.id ">
                    <div style="width: 10%; display: flex; align-items: center; justify-content: center;">{{obj.codQma || 'N/D'}}</div>
                    <div style="width: 10%; display: flex; align-items: center; justify-content: center;">{{obj.revisao || 'N/D'}}</div>
                    <div style="width: 10%; display: flex; align-items: center; justify-content: center;">{{obj.obraCod || 'N/D'}}</div>
                    <div style="width: 15%; display: flex; align-items: center; justify-content: center;">{{obj.servicos || 'N/D'}}</div>
                    <div style="width: 15%; display: flex; align-items: center; justify-content: center;">{{obj.responsavel || 'N/D'}}</div>
                    <div style="width: 15%; display: flex; align-items: center; justify-content: center;">{{obj.dataCriacao || 'N/D'}}</div>
                    <div style="width: 15%; display: flex; align-items: center; justify-content: center;">{{obj.dataAprovacao || 'N/D'}}</div>
                    <div style="break-inside: avoid; width: 20%; display: flex; align-items: center; justify-content: center;" :class="obj.statusQma === 0 ? 'status-pill-wip' :
                                 obj.statusQma === 1 ? 'status-pill-waiting' :
                                 obj.statusQma === 2 ? 'status-pill-aproved' :
                                 obj.statusQma === -1 ? 'status-pill-reproved' : ''">
                                {{ obj.statusQMADescricao }}
                     </div>
                </div>
            </div>
        </div>

    </section>
    </vue-html2pdf>
  </div>

</template>

<script>
import qmaReportPdf from './qmaReportPdf'
export default qmaReportPdf
</script>

<style scoped>

.conteiner_pdf_grafico{
    padding: 0.5rem;
}
.filtro_parametros-pdf{
    width: 100%;
    padding: 0.5rem;
    height: fit-content;
    border-radius: 5px;
}
.pdf-header{
    margin-bottom: 0.5rem;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nome_relatorio-pdf {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: rgb(54, 54, 54);
    font-family:'Poppins';
    margin-bottom: 1rem;
    background: transparent;
}
.report-filter{
    padding: 0.5rem;
    display: flex;
    gap: 1rem;
}
.filtro_parametros-peq{
    width: 100%;
    border-radius: 10px;
    background: #F4F4F4;
}
.filter-text{
    display:flex;
    align-items: center;
    padding: 1rem 0 0 1rem;
}
.border-filter{
    border-radius: 5px;
    background: #E8E8E8;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1rem;
}
.icon-filter{
    color:#2E973D;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro_periodo_atividade{
    display: flex;
    padding: 1rem;
    gap: 1rem;
}
.status_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.periodo_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro{
    display: flex;
    padding: 0 1rem 0 1rem;
    flex-direction: column;
    gap: 1rem;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.filtro_parametros{
    margin-top: 2rem;
    width: 100%;
    height: fit-content;
    background: rgb(236, 236, 236);
    border-radius: 5px;
    padding: 0.5rem
}
.report-qta{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.numerochamados{
    width: 215px;
    height: 6rem;
    border-radius: 10px;
    background: #F4F4F4;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.qtachamado{
    color: #008148;
    text-align: center;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
}
.text-filter{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.text-filter-small{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.container_pdffiltro{
    margin-top: 1.5rem;
    width: 100%;
    padding: 1rem;
    border-radius: 10px;
}
.container_ocorrencias_filtradas{
    width: 100%;
    height: 2.5rem;
    padding: 0 1rem;
    border-radius: 5px 5px 0 0;
    background: #2E973D;
    display: flex;
    align-items: center;
    break-before: avoid;
}
.container_ocorrencias_filtradas > div {
    width: 100%;
}
.container_ocorrencias_filtradas > .codigo_apr, .codigo_apr_result   {
    margin: 5px;
}
.container_ocorrencias_filtradas > .area_apr, .area_apr_result   {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataFim_apr, .dataFim_apr_result   {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataInicio_apr, .dataInicio_apr_result   {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .responsavel_apr, .responsavel_apr_result   {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
}
.container_ocorrencias_filtradas >
.descricao_oce_result,
.descricao_oce {
    width: 60% !important;
    margin: 5px;
}
.container_ocorrencias_filtradas,
.enterprise-report,
.container_ocorrencias_filtradas,
.container_ocorrencias,
.dataFim_apr_result
.dataInicio_apr_result
.responsavel_apr_result
.area_apr_result
.codigo_apr_result
{
    break-inside: avoid;
}
.container_ocorrencias {
    width: 100%;
    display: flex;
    padding: 0 1rem;
    align-items: center;
    justify-content: center;
    border: #f4f4f4 1px solid
}
.container_ocorrencias > div {
    width: 100%;
    margin: 5px;
}

.font{
    color: #FFF;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    justify-content: center;
    border: 1px solid black;
    font-weight: 400;
    line-height: 27px;
}
.codigo_apr {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container_ocorrencias > .codQma-container,
    .revisao-container,
    .codObra-container,
    .servicos-container,
    .resp-container,
    .dt-container{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
}
.status-pill-wip{
    display: flex;
    font-size: 11px !important;
    height: 34px;
    color: #6a6a6a;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    border-radius: 25px;
    align-items: center;
    background: #c0c0c0;
}
.status-pill-aproved {
    display: flex;
    font-size: 11px !important;
    height: 30px;
    color: #133B1A;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;

    border-radius: 25px;
    align-items: center;
    background: #CBE9CF;
}
.status-pill-waiting {
    display: flex;
    font-size: 11px !important;
    flex-wrap: nowrap;
    height: 30px;
    color: #003789;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    border-radius: 25px;
    align-items: center;
    background: #D4EEFD;
}
.status-pill-reproved {
    display: flex;
    font-size: 11px !important;
    height: 30px;
    color: #AB0101;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    border-radius: 25px;
    align-items: center;
    background: #FFD9D9;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportPdf/qmaReportPdf.vue